import { UIComponentProps, UIComponentHandler, UIComponentImpl, UIComponentState, UIDataModel } from '../../../../toolkit/uicomponent';
import { BaseContext } from '../../../../../utils/basecontext';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { CallerSettingsViewImpl } from './callersettingsview';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { CallerSettingsCSSStyleImpl } from './callersettingscss';
import { Strings } from '../../../../../utils/resources/strings';
import { TimeBasedSettingForCallersGroupDtoImpl } from '../../../../../core/dto/timebasedsetting/timebasedsettingforcallersgroupdto';
import { TimeBasedSettingForSpecificCallerDtoImpl } from '../../../../../core/dto/timebasedsetting/timebasedsettingforspecificcallerdto';
import { GroupDto } from '../../../../../core/dto/listtones/groupdto';

export interface CallerSettingsComponentProps extends UIComponentProps
{
    isShuffleOn:boolean;

   onAddToShuffleSelected(isAddToShuffle:boolean):void;
}

export interface CallerSettingsComponentState extends UIComponentState
{
    callerSetting: string;
    groupsList: GroupDto[];
}

export interface CallerSettingsComponentHandler extends UIComponentHandler
{
    onCallerSettingSelected(callerSetting: string): void;
}

export class CallerSettingsComponent extends UIComponentImpl<CallerSettingsComponentProps, CallerSettingsComponentState, UIDataModel> implements
CallerSettingsComponentHandler
{
    
    constructor(props: CallerSettingsComponentProps)
    {
        super(props);

        this.state = {callerSetting: props.context.getResources().getString(Strings.all_callers), groupsList: []};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new CallerSettingsViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new CallerSettingsCSSStyleImpl(applicationContext);
    }

    onCallerSettingSelected(callerSetting: string): void {
        this.setState({callerSetting: callerSetting});

        if(callerSetting === this.getContext().getResources().getString(Strings.add_to_shuffle))
        {
            this.props.onAddToShuffleSelected(true);
        }
        else
        {
            this.props.onAddToShuffleSelected(false);
        }
    }

    getSpecialCallerData(timeBasedSettingForAllCallersDto: TimeBasedSettingForSpecificCallerDtoImpl)
    {
        (this.getView() as CallerSettingsViewImpl).getSpecialCallerData(timeBasedSettingForAllCallersDto);
    }

    getCallerGroupData(timeBasedSettingForAllCallersDto: TimeBasedSettingForCallersGroupDtoImpl)
    {
        (this.getView() as CallerSettingsViewImpl).getCallerGroupData(timeBasedSettingForAllCallersDto);
    }

    setGroupsList(groups: GroupDto[])
    {
        this.setState({groupsList: groups});
    }

    getCallerSettingSelected(): string
    {
        return this.state.callerSetting;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/tunesettings/callersettings/callersettingscomponent.tsx